import { IonContent, IonPage, IonCol, IonRow, IonText, IonList, IonItem, IonLabel, IonIcon, IonCard, IonCardHeader, IonCardContent, IonGrid, IonFab, IonFabButton, IonButton, IonSpinner, IonToast, IonInfiniteScroll, IonInfiniteScrollContent, IonAlert, isPlatform, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './FellowshipPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { addSharp, bookSharp, logOut, people, peopleCircleOutline, person, personAdd, sync } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import ServerDBContext from '../../components/ServerDBContext/ServerDBContext';
import { useDispatch, useSelector } from 'react-redux';
import { ResetPosts, SelectActiveGroupId, SelectGroup, SelectGroupIds, SelectGroupMembers, SelectGroups, SelectPosts, UpdateActiveGroupId, UpdateGroups, UpdatePost, UpdatePosts } from '../../store/FellowshipSlice';
import FellowshipPostCard from '../../components/FellowshipPostCard/FellowshipPostCard';
import { SelectCurrentUser, SelectLoginStatus, SelectNetworkConnected } from '../../store/UserSlice';
import LoginCard from '../../components/LoginCard/LoginCard';
import { UserRouteInfo, UserRouteKeys } from '../../routes/UserRoutes';
import IFellowshipPost from '../../interfaces/IFellowshipPost';
import PrayerStatus from '../../data/PrayerStatus';
import IPrayer from '../../interfaces/IPrayer';
import PrayerService from '../../services/PrayerService';
import ReadingPlanRecordService from '../../services/ReadingPlanRecordService';
import IReadingPlanRecord from '../../interfaces/IReadingPlanRecord';
import { AppMessages } from '../../data/AppMessages';
import DismissibleCard from '../../components/DismissibleCard/DismissibleCard';
import IDismissibleMessage from '../../interfaces/IDismissibleMessage';
import DismissibleMessageService from '../../services/DismissibleMessageService';
import UserRoles from '../../data/UserRoles';
import NetworkNotification from '../../components/NetworkNotification/NetworkNotification';
import FellowshipPostService from '../../services/FellowshipPostService';
import FellowshipSettingsService from '../../services/FellowshipSettingsService';
import JSHelperService from '../../services/JSHelperService';
import IFellowshipGroups from '../../interfaces/IFellowshipGroups';
import DateHelperService from '../../services/DateHelperService';
import DeleteAccountCard from '../../components/DeleteAccountCard/DeleteAccountCard';
import UnregisterGroup from '../../data/UnregisteredGroup';
import { SelectActiveReadingPlanRecord, UpdateActivePlanByIdAsync } from '../../store/BibleStudySlice';
import { ReadingPlanCodeValues, ReadingPlanCodes, createDefaultReadingPlanRecord } from '../../data/ReadingPlans';
import FellowshipHeader from '../../components/FellowshipHeader/FellowshipHeader';
import { menuController } from '@ionic/core/components';
import FellowshipGroupSelectorHeader from '../../components/FellowshipGroupSelectorHeader/FellowshipGroupSelectorHeader';

const FellowshipPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {

  const history = useHistory();
  const dispatch = useDispatch();
  const fellowshipPosts = useSelector(SelectPosts);
  const LoggedIn = useSelector(SelectLoginStatus);
  const dbService = useContext(ServerDBContext);
  const currentUser = useSelector(SelectCurrentUser);
  const currentGroup = useSelector(SelectGroup);
  const memberDetails =  useSelector(SelectGroupMembers);
  const activeGroupId = useSelector(SelectActiveGroupId);
  const lastActiveGroupId = useRef<string>('');
  const userGroups = useSelector(SelectGroups);
  const userGroupsIds = useSelector(SelectGroupIds);
  const [displayToastSuccess, setDisplayToastSuccess] = useState(false);
  const [toastSuccessMessage, setToastSuccessMessage] = useState('Success: Added New Prayer.');
  const [displayToastFailed, setDisplayToastFailed] = useState(false);
  const [toastFailedMessage, setToastFailedMessage] = useState('Error');
  const [disableInfiniteScroll, setDisableInfiniteScroll] = useState(false);
  const [hideGroupSyncCard, setHideGroupSyncCard] = useState(false);
  const [showSyncPlanConfirmation, setShowSyncPlanConfirmation] = useState(false);
  const [hideInstallWebApp, setHideInstallWebApp] = useState(true);
  const [hideGroupFellowshipInstructions, setHideGroupFellowshipInstructions] = useState(false);
  const postSubscriptionLimit = useRef<number>(1);
  const allOriginalNewPostsRead = useRef<boolean>(false);
  const activeGroupHasNewPosts = useRef<boolean>(false);
  const pageBeingViewed = useRef<boolean>(false);
  const postsInLocalDbExist = useRef<boolean>(false);
  const networkConnected = useSelector(SelectNetworkConnected);
  const [showGroupSelector, setShowGroupSelector] = useState(true);

  useIonViewDidEnter(() => {
    pageBeingViewed.current = true;
    if(!isPlatform('hybrid')) {
      // making typescript happy
      const windowNavigator: any = window.navigator;
      // check to see if app installed on ios or android
      const isInstalled = windowNavigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
      setHideInstallWebApp(isInstalled);
      console.log('Is Installed?', isInstalled);
    }
  });

  useIonViewDidEnter(() => {
      // When page loads and new posts are present then userGroups[activeGroupId!].hasNewPosts should be marked false.
      // also verify that all old post have been read before setting false
      // if(allOriginalNewPostsRead.current && fellowshipPosts.length){
      //   allNewPostRead(new Date(fellowshipPosts[0].sortDate!));
      // }
      if((allOriginalNewPostsRead.current && fellowshipPosts.length) || (fellowshipPosts.length < 5 && fellowshipPosts.length > 0)){
        allNewPostRead(new Date(fellowshipPosts[0].sortDate!));
        console.log('mark all read');
      }
  }, [fellowshipPosts]);

  useIonViewDidLeave(() => {
    pageBeingViewed.current = false;
  });

  useEffect(() => {
    if(userGroups && activeGroupId && userGroups?.hasOwnProperty(activeGroupId)) {
      activeGroupHasNewPosts.current = userGroups[activeGroupId].hasNewPosts;
    }
  }, [userGroups, activeGroupId])
  

  useEffect(() => {
    console.log('subscribe-to-posts', LoggedIn, activeGroupId, userGroups, activeGroupId !== lastActiveGroupId.current, lastActiveGroupId.current)
    if(LoggedIn && activeGroupId && userGroups?.hasOwnProperty(activeGroupId) && activeGroupId !== lastActiveGroupId.current) {
      lastActiveGroupId.current = activeGroupId;
      allOriginalNewPostsRead.current = false;
      setDisableInfiniteScroll(true);
      dispatch(ResetPosts());

      if(dbService?.postSubscription !== undefined && 
        dbService?.currentGroup?.id === userGroups[activeGroupId].group.id) {
          // Do NOTHING - Group is already subscribed to posts.
          console.log('do nothing')
      } else {
        FellowshipPostService.getOlderPosts(activeGroupId!, new Date(Date.now()), 5)
          .then(oldPosts => {
            if(oldPosts?.Success && oldPosts?.Data?.length! > 0) {
              const unsubscribedPosts = oldPosts.Data!.map(post => ({...post, subscribed: false}));
              dispatch(UpdatePosts(unsubscribedPosts.map(post => DateHelperService.convertDatesToNumbers(post))));
              postsInLocalDbExist.current = true;
            }

            if(userGroups[activeGroupId].hasNewPosts) {
              allOriginalNewPostsRead.current = false;
            } else {
              allOriginalNewPostsRead.current = true;
            }
            
            // Subscribe to posts
            postSubscriptionLimit.current = 7;
            dbService?.subscribeToPosts(userGroups[activeGroupId].group, postSubscriptionLimit.current, new Date(userGroups[activeGroupId].lastModifiedDate), updateUI);
            setDisableInfiniteScroll(false);
          });
      }
    } else if(!LoggedIn && activeGroupId === UnregisterGroup.id) {
      lastActiveGroupId.current = '';
    }
  
    // userGroups[activeGroupId!].hasNewPosts should be in the reload array for useEffect
    // if hasNewPosts is true then mark it as false if the page is being viewed.
    return () => {}
  }, [LoggedIn, activeGroupId]);

  const updateUI = (added: Array<any>, modified: Array<any>, removed: Array<any>) => {
    console.log(userGroups, activeGroupId, !activeGroupHasNewPosts.current, !pageBeingViewed.current)
    if(added.length > 0) {
        // Only add posts that are not marked hidden
        const subscribedPosts = added.map(post => ({...post, subscribed: true}));
        dispatch(UpdatePosts(subscribedPosts));
        // All new post coming from Cloud DB should be stored locally
        FellowshipPostService.updateFellowshipPosts(
          added.map(post => ({...DateHelperService.convertNumbersToDates(post), subscribed: false})) as IFellowshipPost[]);
        // userGroups[activeGroupId!].hasNewPosts should be marked as true, it gets marked as false when fellowship page is opened
        if(userGroups && activeGroupId && !activeGroupHasNewPosts.current && !pageBeingViewed.current) {
          newUnreadPost();
        }
    }
    if(modified.length > 0){
        const subscribedUpdatedPosts = modified.map(post => ({...post, subscribed: true}));
        dispatch(UpdatePosts(subscribedUpdatedPosts));
        // All updated post coming from Cloud DB should be stored locally
        FellowshipPostService.updateFellowshipPosts(modified.map(post => ({...DateHelperService.convertNumbersToDates(post), subscribed: false})) as IFellowshipPost[]);
        // userGroups[activeGroupId!].hasNewPosts should be marked as true, it gets marked as false when fellowship page is opened
        if(userGroups && activeGroupId && !activeGroupHasNewPosts.current && !pageBeingViewed.current) {
          newUnreadPost();
        }
    }
    if(removed.length > 0){
        // Most often a post is removed from a subscription due to the limit of the posts
        // in the subscription and we don't really want to remove them. When a post is 
        // actually removed we will handle this locally and it will eventual propagate to 
        // the other group members, but it won't be real time for them.
        const unsubscribedPosts = removed.map(post => ({...post, subscribed: false}));
        dispatch(UpdatePosts(unsubscribedPosts));
    }
  }

  const newUnreadPost = () => {
    if(userGroups && activeGroupId) {
      const groups = JSHelperService.deepObjectClone(userGroups) as IFellowshipGroups;
      groups[activeGroupId].hasNewPosts = true;
      dispatch(UpdateGroups(groups));
      FellowshipSettingsService.getFellowshipSettings().then(settingResult => {
        if(settingResult.Success) {
          console.log('Fellowship Settings value 1: ', settingResult.Data);
          const settings = settingResult.Data!;
          if (settings.userFellowshipGroups.hasOwnProperty(activeGroupId)){
            settings.userFellowshipGroups[activeGroupId].hasNewPosts = true;
            FellowshipSettingsService.updateFellowshipSettings(settings).then(updateResult =>
            console.log('NewPost Updated in local DB: ', updateResult));
          }
        }
      });
    }
  }

  const allNewPostRead = (lastSortDate: Date) => {
    // set value indicating that all old post have been read
    allOriginalNewPostsRead.current = true;
    if(userGroups && activeGroupId) {
      const groups = JSHelperService.deepObjectClone(userGroups) as IFellowshipGroups;
      groups[activeGroupId].hasNewPosts = false;
      groups[activeGroupId].lastSortDate = lastSortDate.getTime();
      dispatch(UpdateGroups(groups));
      FellowshipSettingsService.getFellowshipSettings().then(settingResult => {
        if(settingResult.Success) {
          const settings = settingResult.Data!;
          if (settings.userFellowshipGroups.hasOwnProperty(activeGroupId)){
            settings.userFellowshipGroups[activeGroupId] = groups[activeGroupId];
            FellowshipSettingsService.updateFellowshipSettings(settings).then(updateResult =>
            console.log('Updated Settings Result: ', updateResult));
          }
        }
      });
    }
  }
  

  const toggleLike = (post:IFellowshipPost) => {
    console.log(allOriginalNewPostsRead.current);
    let updatedPost = {...DateHelperService.convertNumbersToDates(post)};
    // If the user exist in likesUserId remove it, otherwise add it.
    if(post.likesUserIds.find(id => id === currentUser.id)?.length)
    {
      updatedPost.likesUserIds = post.likesUserIds.filter(id => id !== currentUser.id);
    } else {
      updatedPost.likesUserIds = [...updatedPost.likesUserIds, currentUser.id];
    }

    //
    if(fellowshipPosts.findIndex(indexedPost => indexedPost.id === post.id) < 7 && post.likesUserIds.length <= 20) {
      dbService!.updatePost(updatedPost);
    } else {
      FellowshipPostService.updateFellowshipPost(updatedPost).then(result => {
        if(result.Success) {
          dispatch(UpdatePost(DateHelperService.convertDatesToNumbers(updatedPost)));
        }
      });
    }
  }

  const removePost = (post: IFellowshipPost) => {
    // Note: a blacklisted post table may need to be created and check in case
    // a cached version of a removed post resurfaces to make the app delete it again
    // if it comes down from the cloud.
    // OR we could have a specific query the retrieves all hidden posts with an modifiedDate less than 

    let updatedPost = {...post, title: 'Content Removed', postText: '', comments: [], likesUserIds: [], hidden: true, sortDate: new Date(Date.now())};

    dbService!.updatePost(updatedPost).then(result => {
      if(result.Success) {
        if(!updatedPost.subscribed) {
          dispatch(UpdatePost(dbService!.convertDateToMills(updatedPost)));
        }
      }
    })
  }

  const savePrayer = async (title: string, description: string, postId: string, displayName: string) => {
    const today = new Date(Date.now());

    const currentPrayer: IPrayer = {
      id: 0,
      title: replacePersonPronouns(title, displayName),
      description: replacePersonPronouns(description, displayName),
      status: PrayerStatus.active,
      modifiedDate: today,
      createdDate: today,
      order: Date.now(),
      linkedPostId: postId,
    };
    const response = await PrayerService.createPrayer(currentPrayer);
    if(response.Success) {
      setToastSuccessMessage('PRAY ADDED TO YOUR LIST')
      setDisplayToastSuccess(true);
    }
  }

  const replacePersonPronouns = (text: string, replacementName: string) => {
    let returnText = text.replace('I am', `${replacementName} is`);
    returnText = returnText.replace('I ', `${replacementName} `);
    returnText = returnText.replace(' my ', ` ${replacementName}'s `);
    returnText = returnText.replace('My ', `${replacementName}'s `);
    returnText = returnText.replace(' me', ` ${replacementName}`);
    console.log('replaced', returnText);
    return returnText;
  }

  const loadMorePosts = async (e: CustomEvent<void>) => {
    const lastPostIndex = fellowshipPosts.length - 1;
    console.log('Load MORE', fellowshipPosts, fellowshipPosts[lastPostIndex]);
    if(!!fellowshipPosts[lastPostIndex]?.sortDate)
    {
      // If its the first time a user has logged in then mark all new post as read
      // This makes it so the user doesn't need to scroll all the way to the bottom
      // to make the new posts icon in the tab bar go away.
      if(!postsInLocalDbExist.current) {
        allNewPostRead(new Date(fellowshipPosts[0].sortDate!));
        postsInLocalDbExist.current = true;
      }

      const lastSortDate = new Date(fellowshipPosts[lastPostIndex].sortDate!);

      // If FireStore is Less than the archive then start getting post from local db
      if(userGroups && lastSortDate < new Date(userGroups[activeGroupId!].lastSortDate)) {
        // Get older post from FellowshipPostService local db
        const newPosts = await FellowshipPostService
          .getOlderPosts(activeGroupId!, lastSortDate, 10);
        if(newPosts?.Success && newPosts?.Data?.length! > 0) {
          const unsubscribedPosts = newPosts.Data!.map(post => ({...post, subscribed: false}));
          console.log('Retrieved posts from local DB: ', unsubscribedPosts);
          dispatch(UpdatePosts(unsubscribedPosts.map(post => DateHelperService.convertDatesToNumbers(post))));
        } else {
          // If there are less than 50 posts in the system attempt to get more from cloud DB
          getPostFromCloudDB(lastSortDate);
        }

        // Mark all post read and set the lastSort date to the newest post
        !allOriginalNewPostsRead.current && allNewPostRead(new Date(fellowshipPosts[0].sortDate!));
      } else {
        getPostFromCloudDB(lastSortDate);
      }
      // Reset the InfiniteScroll event to watch for the bottom of the page
      (e.target as HTMLIonInfiniteScrollElement).complete();
    }
  }

  const getPostFromCloudDB = async (lastSortDate: Date) => {
    console.log('Why-getposts ', networkConnected);
    if(networkConnected) {
      // if there are less than 50 post get more post from the cloud DB
      if(fellowshipPosts.length < 50) {
        const newPosts = await dbService?.getOlderPosts(lastSortDate, 10);
        if(newPosts?.Success && newPosts?.Data?.length! > 0) {
          const unsubscribedPosts = newPosts.Data!.map(post => ({...post, subscribed: false}));
          console.log('Retrieved posts from cloud: ', unsubscribedPosts);
          dispatch(UpdatePosts(unsubscribedPosts));
          FellowshipPostService.updateFellowshipPosts(
            unsubscribedPosts.map(post => DateHelperService.convertNumbersToDates(post)));
        } else {
          // Mark all post read and set the lastSort date to the newest post
          // when all post have been loaded into the system
          if(!allOriginalNewPostsRead.current) {
            allNewPostRead(new Date(fellowshipPosts[0].sortDate!));
          }
          setDisableInfiniteScroll(true);
        }
      } else {
        // Mark all post read and set the lastSort date to the newest post
        // When there are at least 50 posts loaded into the system
        !allOriginalNewPostsRead.current && allNewPostRead(new Date(fellowshipPosts[0].sortDate!));
        setDisableInfiniteScroll(true);
      }
    }
  }

  // NOTE: DUPLICATE CODE - FellowshipGroupPage.tsx line 218 - Remove when sync is automatic
  const syncBibleReadingPlan = async (syncCode: string | undefined) => {
    if(syncCode) {
      // Extract ReadingPlanRecord field from sync code
      const codeData = await ReadingPlanRecordService.interpretSyncCode!(syncCode);
      if (codeData) {
        const {startDate, sessionsPerDay, readingPlanCode} = codeData;
        ReadingPlanRecordService.getReadingPlanRecords().then(response => {
          const groupPlanRecord = response.Success ? response.Data?.find(record => record.groupId = currentGroup.id) : undefined;
          if(groupPlanRecord) {
            // if the reading plan code is the same then its the same plan, therefore update it
            if(groupPlanRecord.readingPlanCode === readingPlanCode) {
              const record = {...groupPlanRecord, startDate, sessionsPerDay}
              // updating current reading plan record with data extracted from the sync code
              ReadingPlanRecordService.updateReadingPlanRecord(record).then(result => {
                if(result.Success) {
                    UpdateActivePlanByIdAsync(dispatch, userGroupsIds, result.Data?.id);
                    console.log('updated synced bible reading schedule', codeData, syncCode);
                  } else {
                    setToastFailedMessage('Failed to create your synced Bible reading schedule.');
                    setDisplayToastFailed(true);
                  }
              });
            } else {
              // TO DO: Create Popup with Request to delete current group plan and create a new one, because it has changed
              setToastFailedMessage('Failed Sync: Your group has changed reading plans');
              setDisplayToastFailed(true);
            }
            
          } else {
            // if no reading plan was set up before...
            const newRecord: IReadingPlanRecord = {
              ...createDefaultReadingPlanRecord(readingPlanCode),
              sessionsPerDay, startDate,
              groupId: currentGroup.id,
              name: currentGroup.name
            }; 
            ReadingPlanRecordService.createReadingPlanRecord(newRecord).then(result => {
              if(result.Success) {
                setToastSuccessMessage('Your Bible schedule Reading has been synced with your group.');
                setDisplayToastSuccess(true);
              } else {
                setToastFailedMessage('Failed to create your synced Bible reading schedule.');
                setDisplayToastFailed(true);
              }
            });
          }
        });
      } else {
        setToastFailedMessage('Your group does not have a reading plan yet.');
        setDisplayToastFailed(true);
      }
    } else {
      setToastFailedMessage('Your group does not have a reading plan yet.');
      setDisplayToastFailed(true);
    }
  }

  const dismissMessage = (messageId: string, initiateAction: boolean) => {
    if(initiateAction) {
      setShowSyncPlanConfirmation(true);
    }

    const dismissMessage: IDismissibleMessage = {
      messageId,
      category: props.title,
      timesDisplayed: 1,
      dateDisplayed: new Date(Date.now()),
      dismissed: true,
    }
    DismissibleMessageService.logDismissibleMessage(dismissMessage);
    setHideGroupSyncCard(true);
  }

  const dismissCreatePlan = (messageId: string, initiateAction: boolean) => {
    if(initiateAction) {
      createGroupReadingPlan();
    } else {
      setHideGroupSyncCard(true);
      const dismissMessage: IDismissibleMessage = {
        messageId,
        category: props.title,
        timesDisplayed: 1,
        dateDisplayed: new Date(Date.now()),
        dismissed: true,
      }
      DismissibleMessageService.logDismissibleMessage(dismissMessage).then(
        result => {
          if(result.Success) {
            setHideGroupSyncCard(true);
            setShowGroupSelector(true);
          }
        });
    }
  }

  const dismissInstallMessage = (messageId: string, initiateAction: boolean) => {

    if(initiateAction) {
      history.push(AppRouteInfo[AppRouteKeys.InstallAppInstructions].path, { direction: 'forward' });
    } else {
      const dismissMessage: IDismissibleMessage = {
        messageId,
        category: props.title,
        timesDisplayed: 1,
        dateDisplayed: new Date(Date.now()),
        dismissed: true,
      }
      DismissibleMessageService.logDismissibleMessage(dismissMessage).then(
        result => {
          if(result.Success) {
            setHideInstallWebApp(true);
            setShowGroupSelector(true);
          }
          console.log(result);
        }
      );
    }
  }

  const dismissGroupFellowshipInstructions = (messageId: string, initiateAction: boolean) => {
      const dismissMessage: IDismissibleMessage = {
        messageId,
        category: props.title,
        timesDisplayed: 1,
        dateDisplayed: new Date(Date.now()),
        dismissed: true,
      }
      DismissibleMessageService.logDismissibleMessage(dismissMessage).then(
        result => {
          if(result.Success) {
            setHideGroupFellowshipInstructions(true);
            setShowGroupSelector(true);
          }
          console.log(result);
        }
      );
  }

  const setActiveGroup = (groupId: string) => {
    dispatch(UpdateActiveGroupId(groupId));
    FellowshipSettingsService.getFellowshipSettings().then(result => {
      if(result.Success) {
        const settingToUpdate =  result.Data!;
        settingToUpdate.defaultGroupId = groupId;
        FellowshipSettingsService.updateFellowshipSettings(settingToUpdate);
      }
    });
  }

  const createGroupReadingPlan = async () => {
    if(userGroups && activeGroupId && userGroups?.hasOwnProperty(activeGroupId)) {
      const codeData = await ReadingPlanRecordService.interpretSyncCode!(userGroups[activeGroupId].group.joinCode);
      if (codeData)
      {
        history.push(`${AppRouteInfo[AppRouteKeys.ReadingScheduler].rootPath}/${codeData.readingPlanCode}/new/${activeGroupId}`, {direction: 'forward'});
      } else if(userGroups[activeGroupId].group.creatorId === currentUser.id) {
        history.push(`${AppRouteInfo[AppRouteKeys.BiblePlanSelector].rootPath}/${activeGroupId}`, {direction: 'forward'});
      } else {
        setToastFailedMessage('Failed: Your group does not yet have reading plan. Please contact your group admin.');
        setDisplayToastFailed(true);
      }
    }
  }

  const groupHeaderMenuContent =
    <IonList className="fellowship-page-menu-list">
      <IonItem className="header-menu-item" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroup].path.replace('/:nav?', ''), { direction: 'forward' })}>
        <IonLabel>GROUP DETAILS</IonLabel>
        <IonIcon slot="start" icon={people}></IonIcon>
      </IonItem>
      {
        LoggedIn && memberDetails && Object.keys(memberDetails).length && memberDetails[currentUser.id]?.role === UserRoles.admin ?
        <IonItem className="header-menu-item" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroup].path.replace(':nav?', 'invite'), { direction: 'forward' })}>
          <IonLabel>INVITE MEMBERS</IonLabel>
          <IonIcon slot="start" icon={personAdd}></IonIcon>
        </IonItem> : null
      }
      {
        LoggedIn && 
        <IonItem className="header-menu-item" lines="none" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroup].path.replace(':nav?', 'plan'), { direction: 'forward' })}>
          <IonLabel>GROUP BIBLE PLAN</IonLabel>
          <IonIcon slot="start" icon={bookSharp}></IonIcon>
        </IonItem>
      }
    </IonList>

const accountHeaderMenuContent =
  <IonList className="fellowship-page-menu-list">
    <IonItem className="header-menu-item" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipProfile].path, { direction: 'forward' })}>
      <IonLabel>YOUR PROFILE</IonLabel>
      <IonIcon slot="start" icon={person}></IonIcon>
    </IonItem>
    {/* <IonItem className="header-menu-item" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroup].path, { direction: 'forward' })}>
      <IonLabel>YOUR GROUPS</IonLabel>
      <IonIcon slot="start" icon={people}></IonIcon>
    </IonItem> */}
    <IonItem className="header-menu-item" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroupJoin].rootPath!, { direction: 'forward' })}>
      <IonLabel>JOIN GROUP</IonLabel>
      <IonIcon slot="start" icon={personAdd}></IonIcon>
    </IonItem>
    <IonItem className="header-menu-item" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroupCreate].path, { direction: 'forward' })}>
      <IonLabel>CREATE GROUP</IonLabel>
      <IonIcon slot="start" icon={people}></IonIcon>
    </IonItem>
    <IonItem className="header-menu-item" lines="none" onClick={()=>{dbService?.signOut();}}>
      <IonLabel>LOGOUT</IonLabel>
      <IonIcon slot="start" icon={logOut}></IonIcon>
    </IonItem>
  </IonList>

  return (
    <IonPage id="fellowship-page">
      <FellowshipHeader 
         {...props}
         groupMenuContents={LoggedIn && currentGroup?.id !== UnregisterGroup.id ? groupHeaderMenuContent : undefined} 
         accountMenuContents={LoggedIn ? accountHeaderMenuContent : undefined}></FellowshipHeader>
      <FellowshipGroupSelectorHeader 
         {...props}
         className={showGroupSelector ? 'reveal' : 'hide'}
         userGroups={userGroups}
         activeGroupId={activeGroupId}
         setActiveGroup={setActiveGroup}></FellowshipGroupSelectorHeader>
      <IonContent className="fellowship-content" fullscreen={true} scrollEvents={true}  onIonScroll={(e) => {
        if(e.detail.deltaY && (e.detail.deltaY < 0) !== showGroupSelector) {
          setShowGroupSelector(e.detail.deltaY < 0)
        }
      }}>
        { LoggedIn && !currentGroup?.syncCode && currentGroup?.creatorId === currentUser?.id ?
            <DismissibleCard
              messageId={AppMessages.createBiblePlanForGroup.messageId}
              hideCard={hideGroupSyncCard}
              dismissCard={dismissCreatePlan}
              color='bible'
              buttonText="SET UP READING SCHEDULE"
            >
              {AppMessages.createBiblePlanForGroup.messageBody}
            </DismissibleCard> : undefined
        }
        { LoggedIn && currentGroup?.id !== UnregisterGroup.id &&
          <DismissibleCard
            messageId={AppMessages.installWebAppConnectedGroup.messageId}
            hideCard={hideInstallWebApp}
            dismissCard={dismissInstallMessage}
            color='bible'
            buttonText="Yes, Help Me Install This App"
          >
            {AppMessages.installWebAppConnectedGroup.messageBody}
          </DismissibleCard>
        }
        { LoggedIn && currentGroup?.id !== UnregisterGroup.id &&
          <DismissibleCard
            messageId={AppMessages.fellowshipGroupInstructions.messageId}
            hideCard={hideGroupFellowshipInstructions}
            dismissCard={dismissGroupFellowshipInstructions}
            color='prayer'
            buttonText="Thanks, Got it!"
          >
            {AppMessages.fellowshipGroupInstructions.messageBody}
          </DismissibleCard>
        }
        <IonGrid fixed={true}>
          <IonRow>
            <IonCol>
              {
                LoggedIn && currentGroup?.id !== UnregisterGroup.id && fellowshipPosts.length > 0
                  ? fellowshipPosts.map(post =>
                    !post.hidden &&
                    <FellowshipPostCard key={post.id}
                      post={post}
                      toggleLike={toggleLike}
                      currentUser={currentUser}
                      memberDetails={memberDetails!}
                      savePrayer={savePrayer}
                      removePost={removePost}></FellowshipPostCard>
                  )
                  : LoggedIn && currentGroup?.id !== UnregisterGroup.id 
                    ? <div className="ion-text-center"><IonSpinner name="dots"></IonSpinner><br />Loading Posts</div>
                    : LoggedIn && !networkConnected
                      ? <div className="ion-text-center"><IonSpinner name="dots"></IonSpinner><br />No Network Connection.</div>
                      : null
              }
            </IonCol>
          </IonRow>
        {
          (LoggedIn && currentGroup?.id !== UnregisterGroup.id && disableInfiniteScroll && fellowshipPosts?.length > 50) &&
          <IonRow>
            <IonCol>
              <div className="fellowship-posts-archive-notice">
                Older posts that haven't been loaded on this device have been achieved.
              </div>
            </IonCol>
          </IonRow>
        }
        { 
          !LoggedIn &&
          <IonRow>
            <IonCol>
              <LoginCard></LoginCard>
            </IonCol>
          </IonRow>
        }
        {
          !LoggedIn || (LoggedIn && networkConnected && currentGroup?.id === UnregisterGroup.id) ?
            <IonRow className="ion-text-center">
              <IonCol>
                <IonCard className="group-card-sign-up">
                  <IonCardHeader>
                    <IonIcon color="tertiary" icon={peopleCircleOutline}></IonIcon>
                  </IonCardHeader>
                  <IonCardContent>
                    <IonText>If you have a <b>GROUP CODE</b> click the <i>Join A Group</i> button below to create an account and join your group.</IonText>
                    <IonButton color="tertiary" expand="full" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroupJoin].path.replace('/:loadJoinCode?', ''), { direction: 'forward' })}>
                      <IonLabel>JOIN A GROUP</IonLabel>
                    </IonButton>
                  </IonCardContent>
                </IonCard>
              </IonCol>
              <IonCol>
                <IonCard className="group-card-sign-up">
                  <IonCardHeader>
                    <IonIcon color="tertiary" icon={people}></IonIcon>
                  </IonCardHeader>
                  <IonCardContent>
                    <IonText>If you aren't part of a group and don't have a group code to join a group, start your own and invite people to join!</IonText>
                    <IonButton color="tertiary" expand="full" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroupCreate].path, { direction: 'forward' })}>
                      <IonLabel>CREATE A GROUP</IonLabel>
                    </IonButton>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow> : null
        }
        </IonGrid>
        {
          LoggedIn && currentGroup?.id !== UnregisterGroup.id &&
            <IonFab vertical="bottom" horizontal="end" slot="fixed">
              <IonFabButton color={AppRouteInfo[AppRouteKeys.Fellowship].themeColorName} onClick={() => history.push(AppRouteInfo[AppRouteKeys.FellowshipCreatePost].path.replace('/:postType?/:shareIdentifier?', ''), { direction: 'forward' })}>
                <IonIcon color="light" size="large" icon={addSharp} />
              </IonFabButton>
            </IonFab>
        }
        {
          LoggedIn && currentGroup?.id !== UnregisterGroup.id &&
            <IonInfiniteScroll threshold="100px"
                disabled={disableInfiniteScroll}
                onIonInfinite={(e: CustomEvent<void>) => loadMorePosts(e)}>
                <IonInfiniteScrollContent
                    loadingSpinner="dots"
                    loadingText="Loading more posts..."
                    >
                </IonInfiniteScrollContent>
            </IonInfiniteScroll>
        } {
          // Add bottom spacer if all post are collected to make it so add post button
          // doesn't cover up last post.
          LoggedIn && currentGroup?.id !== UnregisterGroup.id && disableInfiniteScroll &&
           <div className="fellowship-post-spacer"></div>
        }
        <IonAlert
          isOpen={showSyncPlanConfirmation}
          onDidDismiss={() => setShowSyncPlanConfirmation(false)}
          cssClass='my-custom-class'
          header={'Confirm!'}
          message={`<div className="remove-user-pop-over-message">
          Are you sure you want to synchronize your Bible reading schedule with your group?
          <p>
            <b>Note:</b> <i>If you currently have a Bible reading schedule stored on this
              device it will be overwritten and set to your group's schedule. Also, only this device
              will be synced. If you want to use multiple phones, tablets, or computers each will need to be synced.</i>
          </p>
        </div>`}
          buttons={[
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: blah => {
                console.log('Confirm Cancel: SYNC BIBLE READING PLAN');
              }
            },
            {
              text: 'YES',
              handler: () => {
                syncBibleReadingPlan(currentGroup.syncCode);
              }
            }
          ]}
        />
        <IonToast color="success"
          isOpen={displayToastSuccess}
          onDidDismiss={() => setDisplayToastSuccess(false)}
          message={toastSuccessMessage}
          duration={2500} />
        <IonToast color="danger"
          isOpen={displayToastFailed}
          onDidDismiss={() => setDisplayToastFailed(false)}
          message={toastFailedMessage}
          duration={2500} />
        <NetworkNotification noInternetMessage="NO INTERNET CONNECTION DETECTED - Connection is required to access fellowship features."></NetworkNotification>
      </IonContent>
    </IonPage>
  );
};

export default FellowshipPage;
